const FALLBACK_FPS = 60;
const MS_PER_SECOND = 1000;
const MS_PER_MINUTE = 60 * MS_PER_SECOND;
const MS_PER_HOUR = 60 * MS_PER_MINUTE;
const SECONDS_PER_MINUTE = 60;
const SECONDS_PER_HOUR = 60 * SECONDS_PER_MINUTE;
type IFrameToTimeProps = {
  frame: number;
  maxFrames: number;
  frameRate: number | null | undefined;
};
const getHoursMinsSecondsMs = (totalMs: number): [number, number, number, number] => {
  const hours = Math.floor(totalMs / MS_PER_HOUR);
  const mins = Math.floor(totalMs % MS_PER_HOUR / MS_PER_MINUTE);
  const seconds = Math.floor(totalMs % MS_PER_MINUTE / MS_PER_SECOND);
  const ms = Math.floor(totalMs % MS_PER_SECOND);
  return [hours, mins, seconds, ms];
};
export const getFrameToTime = ({
  frame,
  maxFrames,
  frameRate
}: IFrameToTimeProps): string => {
  const fps = frameRate ?? FALLBACK_FPS;
  const totalDurationMs = (maxFrames - 1) / fps * MS_PER_SECOND;
  const [totalHours, totalMins] = getHoursMinsSecondsMs(totalDurationMs);

  // If frame >= maxFrames, use total duration
  const durationMs = frame >= maxFrames ? totalDurationMs : frame / fps * MS_PER_SECOND;
  const [frameHours, frameMins, frameSeconds, frameMs] = getHoursMinsSecondsMs(durationMs);

  // Build time components based on what's present in total duration
  const timeComponents: string[] = [];

  // Include hours only if total duration has hours
  if (totalHours > 0) {
    timeComponents.push(String(frameHours).padStart(2, '0'));
  }

  // Include minutes if total duration has hours or minutes
  if (totalHours > 0 || totalMins > 0) {
    timeComponents.push(String(frameMins).padStart(2, '0'));
  }

  // Always include seconds
  timeComponents.push(String(frameSeconds).padStart(2, '0'));

  // Join time components with ':' and append milliseconds with '.'
  return `${timeComponents.join(':')}.${String(frameMs).padStart(3, '0')}`;
};
export const getTimeToFrame = (time: string, frameRate: number | null | undefined): number => {
  const fps = frameRate ?? FALLBACK_FPS;

  // Split by '.' to separate milliseconds
  const [timePart = '', msPart] = time.split('.');
  const timeComponents = timePart.split(':');
  let hours = 0;
  let minutes = 0;
  let seconds = 0;

  // Parse based on number of components (HH:MM:SS, MM:SS, or SS)
  if (timeComponents.length === 3) {
    hours = Number(timeComponents[0]);
    minutes = Number(timeComponents[1]);
    seconds = Number(timeComponents[2]);
  } else if (timeComponents.length === 2) {
    minutes = Number(timeComponents[0]);
    seconds = Number(timeComponents[1]);
  } else if (timeComponents.length === 1) {
    seconds = Number(timeComponents[0]);
  }
  const totalSeconds = hours * SECONDS_PER_HOUR + minutes * SECONDS_PER_MINUTE + seconds + Number(`0.${msPart || '0'}`);
  return Math.round(totalSeconds * fps);
};